var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogIn01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1017 2.82031H15.2299C16.8094 2.82031 17.5992 2.82031 18.2025 3.12771C18.7332 3.39811 19.1647 3.82957 19.4351 4.36026C19.7425 4.96356 19.7425 5.75334 19.7425 7.33289V15.2299C19.7425 16.8094 19.7425 17.5992 19.4351 18.2025C19.1647 18.7332 18.7332 19.1647 18.2025 19.4351C17.5992 19.7425 16.8094 19.7425 15.2299 19.7425H14.1017M9.40115 6.58079L14.1017 11.2814M14.1017 11.2814L9.40115 15.982M14.1017 11.2814L2.82031 11.2814",
    stroke: "white",
    strokeWidth: 1.88024,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn01);
export default __webpack_public_path__ + "static/media/log-in-01.612870c6d078b9675a7da576280c64bd.svg";
export { ForwardRef as ReactComponent };